module.exports = __webpack_public_path__ + "img/care-offer-3.299548b0.jpg";